import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, Row, Card } from "react-bootstrap";

import AppBreadcrumb from "views/Admin/Layout/AppBreadCrumb";
import Errors from "Notifications/Errors";
import Spinner from "views/Spinner";

import { validateForm } from "utils/validation";

import {
  createCredential,
  cancelSave,
  setErrors,
  removeCredentialErrors,
  resetComponentStore,
} from "actions/credentialActions";

const CreateCredential = ({
  createCredential,
  errorList,
  cancelSave,
  loadingCredential,
  setErrors,
  removeCredentialErrors,
  resetComponentStore,
}) => {
  const navigate = useNavigate();

  const initialFormData = {
    code: "",
    description: "",
  };
  const [formData, setFormData] = React.useState(initialFormData);

  const { code, description } = formData;

  const onChange = (e) => {
    if (!e.target) {
      return;
    }

    switch (e.target.name) {
      default:
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    removeCredentialErrors();

    let validationRules = [
      {
        param: "code",
        msg: "The Code is required",
      },
      {
        param: "description",
        msg: "The Description is required",
      },
    ];

    const errors = validateForm(formData, validationRules);

    if (errors.length) {
      setErrors(errors);
      return;
    }

    const submitData = {};

    for (let i in formData) {
      if (
        formData[i] === "" ||
        formData[i] === null ||
        formData[i] === undefined
      )
        continue;
      submitData[i] = formData[i];
    }

    // console.log("Add App Token Submit data", submitData);
    createCredential(submitData, navigate).then((res) => {
      if (!res.status) return;
    });
  };

  const onClickHandel = (e) => {
    e.preventDefault();
    cancelSave(navigate);
  };

  React.useEffect(() => {
    resetComponentStore();
  }, []);

  return (
    <React.Fragment>
      <AppBreadcrumb
        pageTitle="Create Credential"
        crumbs={[
          { name: "Credentials", path: "/admin/credentials" },
          { name: "Create Credential" },
        ]}
      />

      {loadingCredential ? (
        <Spinner />
      ) : (
        <Row>
          <Col xs="12" sm="6">
            <Card className="card-body">
              <Form onSubmit={(e) => onSubmit(e)} autoComplete="off">
                <h4 className="header-title mb-3">Credential Information</h4>

                <Form.Group className="form-group">
                  <Form.Label htmlFor="code">
                    Code <span>*</span>
                  </Form.Label>
                  <Form.Control
                    className={errorList.code ? "invalid" : ""}
                    type="text"
                    id="code"
                    name="code"
                    maxLength="12"
                    value={code}
                    onChange={(e) => onChange(e)}
                    required
                  />
                  <Errors current_key="code" key="code" />
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label htmlFor="description">
                    Description <span>*</span>
                  </Form.Label>

                  <Form.Control
                    className={errorList.description ? "invalid" : ""}
                    as="textarea"
                    rows={3}
                    id="description"
                    name="description"
                    maxLength="160"
                    value={description}
                    onChange={(e) => onChange(e)}
                    required
                  />

                  <Errors current_key="description" key="description" />
                </Form.Group>

                <br></br>

                <div className="float-end">
                  <>
                    <Button
                      className="m-2"
                      type="submit"
                      size="sm"
                      variant="primary"
                    >
                      Create
                    </Button>
                    <Button
                      className="ml-2"
                      type="reset"
                      size="sm"
                      variant="danger"
                      onClick={onClickHandel}
                    >
                      Cancel
                    </Button>
                  </>
                </div>
              </Form>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

CreateCredential.propTypes = {
  createCredential: PropTypes.func.isRequired,
  errorList: PropTypes.object.isRequired,
  cancelSave: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errorList: state.errors,
  loadingCredential: state.credential.loadingCredential,
});

export default connect(mapStateToProps, {
  createCredential,
  cancelSave,
  setErrors,
  removeCredentialErrors,
  resetComponentStore,
})(CreateCredential);
